<template>
  <div class="result-wrap">
    <back-button :tag="false" />
    <!-- <van-tabs
      class="custom-tabs"
      v-model="activeTab"
      color="#9137f9"
      background="transparent"
      title-active-color="#FFF "
      title-inactive-color="#fff"
      line-width="0"
      line-height="0"
      swipeable
      animated
      type="card"
    >
      <van-tab title="每次成绩" title-class="custom-tab">
        <div class="tab-card">
          <daliy-list />
        </div>
      </van-tab>
      <van-tab title="每周成绩" title-class="custom-tab">
        <div class="tab-card">
          <week-list />
        </div>
      </van-tab>
      <van-tab title="总成绩" title-class="custom-tab">
        <div class="tab-card">
          <total-list @show-tip="showTip" />
        </div>
      </van-tab>
    </van-tabs> -->
    <div class="tab-labels">
      <div
        :class="['tab-label', activeTab == 1 ? 'tab-label-active' : '']"
        @click="activeTab = 1"
      >
        每次成绩
      </div>
      <div
        :class="['tab-label', activeTab == 2 ? 'tab-label-active' : '']"
        @click="activeTab = 2"
      >
        总成绩
      </div>
    </div>
    <div v-if="activeTab == 1" class="tab-card">
      <daliy-list />
    </div>
    <div v-if="activeTab == 2" class="tab-card-liner">
      <total-list @show-tip="showTip" />
    </div>
    <van-dialog
      v-if="tipDialog"
      v-model="tipDialog"
      class="custom-dialog"
      title="提示"
      @confirm="tipDialog = false"
    >
      <div class="custom-dialog_content">
        <div class="custom-dialog-content" style="text-align: center">
          {{ tipMessage }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
// import WeekList from "./WeekList";
import TotalList from "./TotalList";
import DaliyList from "./DailyList";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    // WeekList,
    TotalList,
    DaliyList,
    BackButton,
  },
  data() {
    return {
      activeTab: 1,
      tipDialog: false,
      tipMessage: "",
    };
  },
  methods: {
    showTip(type) {
      switch (type) {
        case 1:
          this.tipMessage = "累计分数为每轮答题得分的累计总分";
          this.tipDialog = true;
          break;
        case 2:
          this.tipMessage = "依次按累计分数、答题正确率、累计时长进行排名";
          this.tipDialog = true;
          break;
        case 3:
          this.tipMessage = "参与所有竞赛答题的正确率";
          this.tipDialog = true;
          break;
        case 4:
          this.tipMessage = "累计每轮答题用时的总时长";
          this.tipDialog = true;
          break;
        default:
          this.tipMessage = "";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  box-sizing: border-box;
  min-height: 100vh;
  overflow: hidden;
  @include plain-bg;
}
.van-tabs {
  ::v-deep .van-tabs__nav {
    padding-right: 60px;
    padding-left: 60px;
  }
}
</style>
